import React, { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IApplicationState } from 'Store/types'
import { addNotHealthyAutoPart } from '../../Actions/reducer'
import { useTranslation } from 'react-i18next'
import VisitsApiPaths from '../../Constants/VisitsApiPaths'
import BottomSheetSelect from 'Components/BottomSheetSelect/BottomSheetSelect'
import Const from 'Utils/Consts'
import Icon from 'Components/Icon'
import { useSettings } from 'Contexts/SettingsContext'

const NotHealthyNewAutoPart = (props: { onCapture: () => void }) => {
  const [t] = useTranslation()
  const { settings } = useSettings()
  const width =
    settings?.REACT_APP_WIDTH != undefined ? settings?.REACT_APP_WIDTH : Const.env.REACT_APP_WIDTH
  const height =
    settings?.REACT_APP_HEIGHT != undefined
      ? settings?.REACT_APP_HEIGHT
      : Const.env.REACT_APP_HEIGHT
  const quality =
    settings?.REACT_APP_IMAGE_QUALITY != undefined
      ? settings?.REACT_APP_IMAGE_QUALITY
      : Const.env.REACT_APP_IMAGE_QUALITY
  const { data, loading } = useSelector(
    (store: IApplicationState) => store.visits.newVisit.notHealthyAutoParts,
  )
  const autoPartsData = useSelector((store: IApplicationState) => store.visits.autoParts.data)
  const dispatch = useDispatch()
  const [facingMode, setFacingMode] = useState<'environment' | 'user'>('environment')
  const [selectedValue, setSelectedValue] = useState<any>(undefined)
  const [notHealthyAutoPartError, setNotHealthyAutoPartError] = useState<boolean>(false)
  const [duplicateError, setDuplicateError] = useState<boolean>(false)
  const [description, setDescription] = useState<string>('')
  const videoRef = useRef<HTMLVideoElement>(null)
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    let stream: MediaStream
    const getCameraStream = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: { width: width, height: height, facingMode: facingMode },
        })

        if (videoRef.current) {
          videoRef.current.srcObject = stream
          if (!videoRef.current.played) videoRef.current.play()
        }
      } catch (error) {
        console.error('Error accessing the camera', error)
      }
    }

    getCameraStream()

    return () => {
      stream?.getTracks()?.forEach(track => track?.stop())
    }
  }, [facingMode])

  const handleCapture = () => {
    setNotHealthyAutoPartError(selectedValue == undefined)

    if (selectedValue) {
      var id = selectedValue?.value
      var name = selectedValue?.label
      if (!data.some(x => x.id == id)) {
        if (videoRef.current && canvasRef.current) {
          const context = canvasRef.current.getContext('2d')
          if (context) {
            canvasRef.current.width = width
            canvasRef.current.height = height
            context.drawImage(
              videoRef.current,
              0,
              0,
              canvasRef.current.width,
              canvasRef.current.height,
            )
            dispatch(
              addNotHealthyAutoPart({
                id: id,
                name: name,
                description: description,
                image: canvasRef.current.toDataURL('image/png', quality),
                fileType: 'image/png',
                status: 0,
                uploadProgress: 0,
              }),
            )
            setSelectedValue(undefined)
            setDescription('')
            props.onCapture()
          }
        }
      } else {
        setDuplicateError(true)
      }
    }
  }

  return (
    <div className="space-y-4">
      <BottomSheetSelect
        id="notHealthyAutoPart"
        name="notHealthyAutoPart"
        onChange={(data: any) => {
          setSelectedValue(data)
          setNotHealthyAutoPartError(selectedValue == undefined)
          setDuplicateError(false)
        }}
        errors={notHealthyAutoPartError ? { type: 'required' } : null}
        value={selectedValue}
        label={t('AUTO_PART')}
        withSearch
        options={autoPartsData}
      />

      <div className={`group form-floating w-full relative`}>
        <textarea
          id="description"
          name="description"
          className="form-text transition-all"
          value={description}
          onChange={e => {
            setDescription(e.target.value)
          }}
        />
        <label
          htmlFor="outline"
          className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3"
        >
          <span className="relative">{t('DESCRIPTION')}</span>
        </label>
      </div>

      <div style={{ position: 'relative', textAlign: 'center', marginTop: 16 }}>
        <div style={{ position: 'relative' }}>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{ width: '100%', height: '250px', objectFit: 'cover', objectPosition: 'center' }}
          />
          <canvas ref={canvasRef} style={{ display: 'none' }} />

          <Icon
            name="Cameraswitch"
            onClick={() => setFacingMode(facingMode == 'environment' ? 'user' : 'environment')}
            style={{
              position: 'absolute',
              top: 7,
              right: 10,
              fontSize: 25,
              color: 'rgba(255, 255, 255, 0.7)',
            }}
          />
        </div>
      </div>
      <button
        className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full mt-3"
        onClick={handleCapture}
      >
        <Icon name="camera" className="w-6 h-6" />
        {t('SAVE_IMAGE')}
      </button>

      {duplicateError && (
        <div
          id="alert-error"
          className="flex items-center p-3 text-white rounded-xl bg-gray-800 dark:bg-gray-800"
          role="alert"
        >
          <div className="bg-error/[.16] text-error p-2 rounded-lg flex justify-center items-center">
            <Icon name="ic_error" className="w-6 h-6" />
          </div>
          <span className="sr-only">error</span>
          <div className="ms-3 text-sm font-semibold grow">
            {t('DUPLICATE_AUTO_PART_MESSAGE', 'قطعه اضافه قبلا انتخاب شده است')}
          </div>
        </div>
      )}
    </div>
  )
}

export default NotHealthyNewAutoPart
